import React, { PropsWithChildren } from "react";

export class CenterLayout extends React.Component<PropsWithChildren> {
  render() {
    return this.props.children;
  }
}
